module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-dialog', {
    attrs: {
      "open": _vm.isShow
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "#838383",
      "position": "fixed",
      "top": "0",
      "left": "0",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#000",
      "background-color": "F2F2F2",
      "position": "fixed",
      "z-index": "10",
      "top": "10px",
      "left": "20%"
    },
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('iframe', {
    staticClass: "game-iframe",
    attrs: {
      "name": "openGames",
      "src": _vm.gameUrl,
      "scrolling": "no"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-71bb4fa6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/train/verbalGames.vue
// module id = 1005
// module chunks = 2